import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

import colors from '../../design/color-names.js'
import { shouldForwardProp } from '../../helpers/styled.ts'

const imageSvg = `<svg width="16" height="26" viewBox="0 0 16 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="6" height="6" fill="#E9E9E9"/>
<rect y="10" width="6" height="6" fill="#E9E9E9"/>
<rect y="20" width="6" height="6" fill="#E9E9E9"/>
<rect x="10" width="6" height="6" fill="#E9E9E9"/>
<rect x="10" y="10" width="6" height="6" fill="#E9E9E9"/>
<rect x="10" y="20" width="6" height="6" fill="#E9E9E9"/>
</svg>`

interface StyledWidgetListItemProps {
  isDragging: boolean
}

export const StyledWidgetListItem = styled('li', {
  shouldForwardProp: (prop) => shouldForwardProp(['isDragging'], prop),
})<StyledWidgetListItemProps>`
  position: relative;
  border-radius: 3px;
  list-style-type: none;

  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(122, 122, 122, 0.25);
  background-color: #fff;
  margin-right: 6px;

  padding: 16px 16px 16px 42px;
  min-height: 57px;

  cursor: grab;

  :not(:last-of-type) {
    margin-bottom: 15px;
  }

  :hover {
    box-shadow: 0px 0px 10px rgba(160, 160, 160, 0.7);
  }

  :afetr {
    background-image: svg-load('../../img/icons/info.svg');
  }

  :before {
    position: absolute;
    top: 18px;
    left: 16px;
    content: '';
    display: block;
    width: 12px;
    height: 21px;
    background-size: 12px 21px;

    background-repeat: no-repeat;
    background-image: url('data:image/svg+xml;charset=utf8,${encodeURIComponent(
      imageSvg,
    )}');
    background-position: center;
  }

  ${({ isDragging }) => (isDragging ? 'outline: 2px solid var(--java);' : '')}

  ::marker {
    display: none;
  }
`

interface StyledStageListProps {
  isDraggingOver: boolean
}

export const StyledStageList = styled('ul', {
  shouldForwardProp: (prop) =>
    shouldForwardProp<StyledStageListProps>(['isDraggingOver'], prop),
})<StyledStageListProps>`
  min-height: 654px !important;

  background-color: white;
  padding-bottom: 20px;
  margin-top: 30px;

  ${(props) =>
    props.isDraggingOver
      ? `background-color: #ECF7F9;`
      : 'background-color: white'};
`

interface StyledStageItemProps {
  selected: boolean
  invalid: boolean
  isDragging?: boolean
}

export const StyledStageItem = styled('li', {
  shouldForwardProp: (prop) =>
    shouldForwardProp<StyledStageItemProps>(
      ['selected', 'invalid', 'isDragging'],
      prop,
    ),
})<StyledStageItemProps>`


  position: relative;

  transition: all 0.2s ease-in-out 0s

  min-height: 48px;

  display: flex;
  justify-content: center;
  background-color: white;
 

  :hover {
    border: 2px solid  #3DC6F5;
    background-color: #F5FBFC;
    z-index: 20;
    cursor: grab;
  }

  &:hover .controls {
    opacity: 1;
  }

  border: 2px solid white;
  ${({ selected, invalid }) =>
    selected
      ? `
        background-color: #FFFFFF;
        border: 2px solid #3DC6F5;
        .label-dinamic-field{
          color: #16a7cd;
        }

       `
      : invalid
        ? `
          border: 2px solid #FF8D84  !important;
          `
        : ''}


        ${({ isDragging }) => (isDragging === true ? 'cursor: grabbing !important; opacity: 0.8;' : '')}

`

interface StyledStageItemControlsProps {
  selected: boolean
}

export const StyledStageItemControls = styled('div', {
  shouldForwardProp: (prop) =>
    shouldForwardProp<StyledStageItemControlsProps>(['selected'], prop),
})<StyledStageItemControlsProps>`
  position: absolute;
  left: 15px;
  top: 8px;
  opacity: 0;

  .e-button {
    float: none;
  }

  .e-button + .e-button {
    margin-left: 8px;
  }

  ${({ selected }) => (selected ? 'opacity: 1;' : '')}
`

export const StyledStageItemContent = styled.div`
  max-width: 600px;
  flex: 1;
  min-height: 45px;
  padding: 10px 50px;
`

export const StyledStageItemExtraInfo = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: inline-flex;
  align-items: center;
`

const placeholder = keyframes`
  0%   { min-height: 0; }
  100% { min-height: 60px; }
  `

export const StyledPlaceholder = styled.div`
  animation: ${placeholder} 250ms 0s linear forwards;

  background-color: ${colors.wildSand};
`
